/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import CrmNoteHeader from "./Header/CrmNoteHeader";
import SaveNotePopup from "./Popup/SaveNotePopup";
import AddNewNotePopup from "./Popup/AddNewNotePopup";
import NoteListFilterPopup from "./Popup/NoteListFilterPopup";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CrmNoteListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();
  const todayValue = new Date().toISOString().split("T")[0];
  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const commonHeaderObject = crmCommonHeaderLinkLists(t);

  const [isLoading, setIsLoading] = useState(false);
  const [noteList, setNoteList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedNoteIds, setSelectedNoteIds] = useState([]);

  const [selectedNoteId, setSelectedNoteId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query — starts as null so we can distinguish
  // "not yet decided" vs "decided: no filter"
  // null   = filter popup hasn't told us what to do yet (skip API call)
  // []     = filter popup said: no default filter, fetch all
  // [...]  = filter popup said: use these filters
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });
  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all contacts
  const getNoteList = async (filterQuery = []) => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_CRM_NOTE +
        `?filternotetype=1`;

      if (filterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = filterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("request url------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response ------>", response);

      setIsLoading(false);

      if (response.status) {
        setNoteList(response.data);
        // resetFilterData();
        setMessageType("success");
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  //function for change status
  const changeStatusHandler = async () => {
    let responseArr = [];
    for (let selectedId of selectedNoteIds) {
      try {
        let invoiceData = {
          status: "0",
        };
        let requestUrl =
          url.API_BASE_URL +
          url.API_DELETE_INVOICE +
          `/${selectedId}` +
          ``;

        const response = await putData(requestUrl, invoiceData);

        if (response.status) {
          responseArr.push(true);
          setMessageType("success");
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }

      setShowAlert(true);
    }

    if (responseArr.length > 0) {
      setTimeout(() => {
        getNoteList();
      }, 1500);
    }
  };

  //function for remove tag from note
  const removeTagFromNote = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_NOTE; // Assuming a new API endpoint for notes
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedNoteId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setNoteList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Action"),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#saveNote"
          aria-controls="saveNote"
          onClick={() => {
            setSelectedNoteId(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
    },
    {
      accessorKey: "notetitle",
      header: t("Title"),
      size: 200,
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tags && row.original.tags.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tags &&
                  row.original.tags.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedNoteId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromNote([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedNoteId &&
                          selectedNoteId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedNoteIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "moduleslug",
      header: t("Module"), //lead title
      size: 150,
    },
    {
      accessorKey: "componentname",
      header: t("Component"), //lead,contact
      size: 200,
      Cell: ({ row }) => (
        <div className="title border-bottom-0">
          <div className="d-flex align-items-center gap-4">
            <Link
              to={
                row.original.moduleslug === "lead"
                  ? `/admin/crm/lead/information/${row.original.leadid}`
                  : row.original.moduleslug === "contact"
                    ? `/admin/crm/contact/details/timeline/${row.original.contactid}`
                    : row.original.moduleslug === "opportunity"
                      ? `/admin/crm/opportunity/save/${row.original.invoiceid}`
                      : row.original.moduleslug === "invoice"
                        ? `/admin/invoice/details/${row.original.invoiceid}`
                        : row.original.moduleslug === "task"
                          ? `/admin/task/details/${row.original.taskid}`
                          : row.original.moduleslug === "invoicedoc"
                            ? `/admin/invoicedoc/details/${row.original.invoicedocid}`
                            : "#"
              }
              className="d-flex align-items-center gap-1 fs-md"
            >
              {row.original.componentname}
            </Link>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "notedate",
      header: t("Date"),
      size: 200,
    },
    {
      accessorKey: "ownerofcomponent",
      header: t("Owner of Element"),
      size: 200,
    },
    {
      accessorKey: "moderatorname",
      header: t("Owner of Note"),
      size: 200,
    },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [i18n.language, noteList, selectedTagId, selectedNoteId],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedNoteIds(selectedIdsArray);
    } else {
      setSelectedNoteIds([]);
    }
  }, [rowSelection]);

  // Pagination save effect
  useEffect(() => {
    if (pagination.pageIndex > 0 || pagination.pageSize > 10) {
      setLastPagination({
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  // ✅ Single API trigger — fires only after filter popup has decided what to do.
  // jsonFilterQuery starts as null (popup not ready yet).
  // Popup sets it to [] (no default filter → fetch all) or [...] (has filters → fetch filtered).
  // This way only ONE api call happens — never two.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // Popup hasn't responded yet, wait

    if (jsonFilterQuery.length > 0) {
      getNoteList(jsonFilterQuery); // Filter query exists → filtered fetch
    } else {
      getNoteList([]); // No filter → fetch all
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Reload effect — triggered by reset or refresh button
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getNoteList([]);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  // ─── Reset ───────────────────────────────────────────────────────────────────

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const resetFilterData = () => {
    setRowSelection({});
    setSelectedNoteIds([]);
    setJsonFilterQuery(null);

    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setIsFilterReset(true);

    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  return (
    <div id="content_wrapper">
      <section className="crm-wrapper bg-white pb-5">
        <TabsHeader
          commonHeaderObject={commonHeaderObject}
          activeOption={t("Notes")}
        />
        <div className="container-fluid px-lg-5">
          <CrmNoteHeader
            reloadList={refreshRecords}
            jsonFilterQuery={jsonFilterQuery ?? []}
            selectedNoteIds={selectedNoteIds}
          />

          {isLoading || !isDataReady ? (
            <LoadingSkeleton />
          ) : (
            <div className="table-wrapper">
              <MaterialReactTable
                columns={columns}
                data={noteList}
                enableGrouping
                enableRowSelection
                getRowId={(row) => `${row._id}`}
                onRowSelectionChange={setRowSelection}
                state={{
                  rowSelection,
                  pagination: lastPagination,
                  columnVisibility: visibleColoumns,
                  columnOrder: columnOrder,
                }}
                onPaginationChange={setPagination}
                initialState={{
                  rowSelection,
                  pagination: lastPagination,
                  columnVisibility: visibleColoumns,
                  columnOrder: columnOrder,
                }}
                enableColumnOrdering={true}
                onColumnVisibilityChange={onColumnVisiblityHandler}
                onColumnOrderChange={changeColumnOrderHandler}
                defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                enableStickyHeader
                renderRowActionMenuItems={({ row }) => {
                  const noteId = row.original._id;
                  const menuItems = [];
                  const isAdmin = ["ADMIN", "SUPER_ADMIN"].includes(
                    userInfo.role.slug,
                  );
                  const isOwner =
                    userInfo._id.toString() ===
                    row.original.moderator.toString();

                  // Update section
                  if (isAdmin || isOwner) {
                    menuItems.push(
                      <MenuItem key="update">
                        <button
                          className="dropdown-item"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#saveNote"
                          aria-controls="saveNote"
                          onClick={() => {
                            setSelectedNoteId(noteId);
                          }}
                        >
                          {t("Update Note")}
                        </button>
                      </MenuItem>,
                    );
                  }

                  // Always show View Details
                  menuItems.push(
                    <MenuItem key="details">
                      <Link
                        className="dropdown-item"
                        to={`/admin/crm/note/information/${noteId}`} // Assuming a new route for note details
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                  );

                  // Delete section
                  if (isAdmin || isOwner) {
                    menuItems.push(
                      <MenuItem key="delete">
                        <Link
                          className="dropdown-item text-danger"
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#deletewarning"
                          onClick={() => {
                            setSelectedNoteIds([noteId]);
                          }}
                        >
                          {t("Delete")}
                        </Link>
                      </MenuItem>,
                    );
                  }

                  return menuItems;
                }}
              />
            </div>
          )}
        </div>
      </section>

      {/* create new note in any component */}
      <AddNewNotePopup
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
        afterPopupClose={() => {
          setTimeout(() => {
            getNoteList();
          }, 2500);
        }}
      />

      {/* update or add new note in same component */}
      <SaveNotePopup
        selectedNoteId={selectedNoteId}
        setSelectedNoteId={setSelectedNoteId}
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
        afterPopupClose={() => {
          setTimeout(() => {
            getNoteList();
          }, 2500);
        }}
      />

      <NoteListFilterPopup
        moduleSlug="crmnotes"
        visibleColoumns={visibleColoumns}
        setVisibleColoumns={setVisibleColoumns}
        columnOrder={columnOrder}
        setColumnOrder={setColumnOrder}
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={refreshRecords}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columns={columns}
      />

      <AddLabelModal
        moduleName="crmnote"
        selectedIds={selectedNoteIds}
        afterTagModalClose={afterModalActionClose}
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
        onModalClose={() => {
          setSelectedNoteIds([]);
          setRowSelection({});
        }}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default CrmNoteListBody;
